// extracted by mini-css-extract-plugin
module.exports = {"switch":"ToggleSwitch_switch__3OL2c","slider":"ToggleSwitch_slider__9nptb","round":"ToggleSwitch_round__3RHLW"};